import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import {
  SemiConfigFormValues,
  SemiConfigClone,
  getTableTitleMessage,
  useProductFromQueryParam,
} from '../ProductsConfiguration'
import useSearch from '../useSearch'
import ClonesTable from './TableComponents/ClonesTable'

const PreDesignedShRNA = () => {
  const formik = useFormikContext<SemiConfigFormValues>()
  const [searchResults, setSearchResults] = useState<SemiConfigClone[]>([])
  const [resultCount, setResultCount] = useState<number>(0)
  const { searchQuery } = useSearch()
  const product = useProductFromQueryParam()

  useEffect(() => {
    const loadData = async () => {
      const data = await searchQuery({})
      if (data && typeof data === 'object') {
        setResultCount(data.count)
        if (data?.reagents && data.reagents.length > 0) {
          const result = data.reagents.map((clone: any) => {
            const subSetInfo = clone.refSeq
              ? [
                  {
                    geneId: clone.geneId || '',
                    geneSymbol: clone.geneSymbol || '',
                    matchType: '',
                    refSeqId: [clone.refSeq],
                  },
                ]
              : []

            return {
              geneId: clone.geneId || '',
              geneSymbol: clone.geneSymbol || '',
              species: clone.species || '',
              price: clone.price?.toString() || null,
              currency: clone.currency || null,
              moreInformation: '',
              region: clone.region || '',
              cloneId: clone.trcId || '',
              trcId: clone.trcId || '',
              targetSeq: clone.targetSeq || '',
              subSetInfo: subSetInfo,
              ncbiGeneId: clone.geneId || '',
              ncbiGeneSymbol: clone.geneSymbol || '',
              targetSequence: clone.targetSeq || '',
              synonyms: clone.synonyms || [],
              cellType: clone.cellType || '',
              method: clone.method || '',
              knockdown: clone.knockdown || '',
              trcVersion: clone.trcVersion || '',
              validated: clone.validated || '',
            }
          })
          setSearchResults(result)
        } else {
          setSearchResults([])
        }
      } else {
        setSearchResults([])
        setResultCount(0)
      }
    }
    loadData()
  }, [formik.values.searchData])

  const titleMessage = getTableTitleMessage(product)

  return (
    <ClonesTable
      tableTitle={
        <FormattedMessage
          id={titleMessage.id}
          defaultMessage={titleMessage.defaultMessage}
        />
      }
      tableData={searchResults}
      totalCount={resultCount}
      showPaginationAndSort
    />
  )
}

export default PreDesignedShRNA
